import React, { useEffect, useRef, useState } from "react";

/** Libraries */
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

/** Components */
import { fadeIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";

/** style */
import "../../../Assets/scss/MedicalCounsellingIndia/pages/home.scss";
import CommonContactButton from "../../Components/AnotherButton/CommonContactButton";
import MetaTags from "../../Components/MetaTags";
import "./DirectAdmissionInBptInPune.scss";

/** top college details */

function MbaAdmission() {
  const [formLoading, setFormLoading] = useState(false);
  const collegeSectionRef = useRef(null);
  const location = useLocation();

  // const collegeTitle = collegeName
  // .split("-")
  // .map((curElem) => {
  //   if (exceptions.includes(curElem)) return curElem;
  //   return curElem.charAt(0).toUpperCase() + curElem.slice(1);
  // })
  // .join(" ");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    console.log(data);
    setFormLoading(true);
    toast.success("Your message has been sent successfully!", {
      theme: "colored",
    });

    setTimeout(() => {
      setFormLoading(false);
    }, 1000);
  };

  const handleKeyDown = (event) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    const isNumberKey = !isNaN(Number(event.key)) && event.code !== "Space";

    if (!allowedKeys.includes(event.code) && !isNumberKey) {
      event.preventDefault();
    }
  };

  /** scroll to college */

  useEffect(() => {
    if (
      location.search.includes("scrollToCollege=true") &&
      collegeSectionRef.current
    ) {
      collegeSectionRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("hi");
    }
  }, [location.search]);

  return (
    <>
      <MetaTags
        title="MBA Admission 2026 India | Counselling India"
        description="Planning MBA Admission 2026? Get expert college counselling and admission support from Counselling India. Call today: 9730858444."
        keywords="MBA Admission 2026  in 2026"
      />

      {/* banner Parallax Scrolling End */}

      {/* instruction section start  */}
      <section className="bg-lightgray py-[150px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[100px]">
        <Container>
          {/* How to get Admission */}
          <div className="">
            <div>
              <div className="!text-[#616162] mt-4  ">
                <h1 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-normal">
                  MBA Admission 2026 – Counselling India
                </h1>
                <div className="mt-3">
                  As the demand for future-ready business leaders rises, the
                  pursuit of an MBA in India continues to gain momentum. With
                  2026 admissions approaching, thousands of students and working
                  professionals are gearing up to secure seats in top-tier MBA
                  colleges. Whether you're aiming for IIMs, top private
                  universities, or global-standard B-schools in India,
                  <b>Counselling India</b> is your trusted partner for
                  <b>MBA Admission 2026. </b>
                </div>
                <div className="mt-2">
                  We understand that gaining admission into a reputed management
                  institute can be both exciting and overwhelming. That’s why
                  our team at Counselling India is here to simplify the process
                  with expert guidance, personalized support, and strategic
                  planning tailored to your career goals.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <CommonContactButton />
          </div>

          {/* general eligibility */}

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Start Preparing for MBA Admission 2026 Now?
            </h2>
            <div>
              <p className="!text-[#616162]">
                MBA admissions are highly competitive. Entrance exams like CAT,
                XAT, NMAT, and MAT require focused preparation. Moreover, top
                colleges have limited seats and strict admission timelines.
                Early preparation gives you:
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-decimal">
                <li>More time to prepare for exams</li>
                <li>Clarity in choosing the right MBA specialization</li>
                <li>
                  A strategic advantage in shortlisting colleges and application
                  planning
                </li>
                <li>
                  Time to explore management quota, NRI quota, or direct
                  admission options if needed
                </li>
              </ol>
              <p>
                With Counselling India, you get a head start with structured
                timelines, entrance preparation support, and a clear college
                roadmap for MBA Admission 2026.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              MBA Admission 2026 – Key Routes
            </h2>
            <div>
              <p className="!text-[#616162]">
                At Counselling India, we assist students through multiple
                admission channels for MBA in India:
              </p>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <div>
                    <b>1. Entrance-Based Admission</b>
                    Colleges that accept scores from:
                  </div>
                  <ol>
                    <li> -CAT (Common Admission Test)</li>
                    <li>- XAT (XLRI Admission Test)</li>
                    <li>- NMAT by GMAC</li>
                    <li>- CMAT (AICTE)</li>
                    <li>- MAT (AIMA)</li>
                    <li>- SNAP (Symbiosis)</li>
                    <li>- ATMA, TISS-NET, MICAT, and others</li>
                  </ol>
                  <div>
                    We provide full support in choosing the right exams,
                    registration assistance, and selecting colleges that match
                    your performance.
                  </div>
                </li>
                <li className="mt-3">
                  <div>
                    <b>2. MBA Admission Through Management Quota (2026)</b>
                  </div>
                  <ol>
                    <li>Seat booking</li>
                    <li>College selection</li>
                    <li>Documentation & fee guidance</li>
                    <li>Ensuring a legal, transparent process</li>
                    <li>MAT (AIMA)</li>
                    <li>SNAP (Symbiosis)</li>
                    <li>ATMA, TISS-NET, MICAT, and others</li>
                  </ol>
                  <div>
                    This is ideal for students seeking hassle-free admission
                    without losing a year.
                  </div>
                </li>
                <li className="mt-3">
                  <div>
                    <b>3. NRI / Sponsored Category Admissions</b>
                  </div>
                  <ol>
                    <li>Eligibility for NRI quota</li>
                    <li>Required documentation</li>
                    <li>Seat confirmation process</li>
                    <li>Fee structure and conversion options</li>
                  </ol>
                </li>
              </ol>
              <p className="mt-2">
                It’s important to understand that MBA Admission Through
                Management Quota is not a shortcut but an alternative route for
                capable students who missed the cutoff.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Top MBA Colleges for Admission in 2026
            </h2>
            <div>
              <p className="!text-[#616162]">
                We help students secure admission in India’s leading MBA
                institutions, such as:
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 ">
                <li>
                  <b>NMIMS (Mumbai, Bangalore, Hyderabad)</b>
                </li>
                <li className="mt-2">
                  <b>
                    Symbiosis Institute of Business Management (SIBM Pune,
                    SCMHRD){" "}
                  </b>
                </li>
                <li className="mt-2">
                  <b>Christ University (Bangalore)</b>
                </li>
                <li className="mt-2">
                  <b>Amity Business School (Noida)</b>
                </li>
                <li className="mt-2">
                  <b>XIME (Bangalore, Chennai, Kochi)</b>
                </li>
                <li>
                  <b>
                    Jain University, Alliance University, ISBR, IFIM, and more
                  </b>
                </li>
                <div>
                  Our counselors help you compare rankings, specializations,
                  placements, and ROI to make an informed decision for MBA
                  Admission 2026.
                </div>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Our Services for MBA Admission 2026
            </h2>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <b>✅ Free Profile Evaluation</b>
                  <div>
                    We analyze your academic record, entrance test status, work
                    experience, and preferences to build your MBA admission
                    profile
                  </div>
                </li>
                <li>
                  <b>✅ College Shortlisting</b>
                  <p>
                    Based on your budget, location, and specialization
                    interests, we recommend the best-suited colleges with
                    detailed comparisons.
                  </p>
                </li>
                <li>
                  <b>✅ Direct Admission Support</b>
                  <p>
                    If you miss the cut-off or want guaranteed admission, we
                    help secure your seat under the management quota or NRI
                    quota for 2026.
                  </p>
                </li>
                <li>
                  <b>✅ Application Assistance </b>
                  <p>
                    Our team assists with form filling, SOP writing,
                    documentation, and error-free submissions to ensure you meet
                    all college requirements.
                  </p>
                </li>

                <li>
                  <b>✅ Interview & GD Prep </b>
                  <p>
                    We provide mock interview sessions, GD topic preparation,
                    and expert tips to clear college-level selection rounds
                    confidently.
                  </p>
                </li>
                <li>
                  <b>✅ Post-Admission Support</b>
                  <p>
                    {" "}
                    From hostel allocation to orientation support, we stay with
                    you until you settle into your MBA college.
                  </p>
                </li>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Counselling India?
            </h2>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>🎓 20+ Years of Experience in MBA admissions</li>{" "}
                <li>🤝 Tie-ups with 100+ Top Colleges across India</li>
                <li>💼 Transparent and Legal Admission Process</li>
                <li>
                  📍 Pan-India Support for Pune, Bangalore, Mumbai, Delhi,
                  Chennai, Hyderabad, and more
                </li>
                <li>
                  ⭐ Thousands of Success Stories across MBA, PGDM, and
                  Executive MBA programs
                </li>
              </ol>

              <p className="mt-3">
                We understand the importance of your career — and we ensure you
                don’t compromise on your dream due to delays, misinformation, or
                test score limitations.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Specializations Offered in 2026 Admissions
            </h2>
            <div>
              <p className="!text-[#616162]">
                We help you gain admission to industry-relevant MBA programs,
                including:
              </p>
            </div>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>MBA in Marketing</li> <li>MBA in Finance</li>
                <li>ID proof (Aadhaar/PAN/Passport)</li>
                <li>MBA in Business Analytics</li>
                <li>MBA in Human Resource Management</li>
                <li>MBA in International Business</li>
                <li>MBA in Operations and Supply Chain</li>
                <li>MBA in IT/Systems</li>
                <li>MBA in Agri-Business, Healthcare, and more </li>
              </ol>
              <p>
                Let Counselling India help you choose the specialization that
                best fits your skillset and market demand.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Final Thoughts
            </h2>

            <div>
              Your journey toward an MBA doesn’t begin at the college gate — it
              begins now. With expert consultants, personalized strategy, and a
              clear roadmap, you can secure admission in top B-schools for MBA
              Admission 2026.
            </div>
            <div>
              At Counselling India, we ensure that the dream of an MBA degree
              doesn’t remain a dream — it becomes a reality through expert
              guidance, timely action, and the right support system.
            </div>
            <div>
              📞 Start Your MBA 2026 Journey Today Speak to our expert
              counselors at Counselling India and take the first step toward
              your dream MBA career.
            </div>
          </div>

          <div className="mt-[50px]">
            <h2>FAQ’S</h2>

            <h6 className="mt-6">
              ❓ FAQ 1: When should I start preparing for MBA Admission 2026?
            </h6>
            <p>
              Students aiming for MBA Admission 2026 should ideally start
              preparing at least a year in advance. This means you should begin
              your research and preparation by mid-2026. Start by shortlisting
              your target B-schools, checking their eligibility criteria, and
              understanding which entrance exams they accept, such as CAT, XAT,
              SNAP, MAT, or GMAT. For MBA Admission 2026, many top colleges
              begin their application process as early as September or October
              2026 for the first rounds. This is especially true for IIMs and
              top private B-schools. Preparing early gives you time to plan your
              entrance exam strategy, take mock tests, improve weak areas, and
              build your profile through internships or work experience. Keeping
              your documents ready, such as your final-year mark sheets,
              identity proofs, and work experience certificates, will also help.
              If you plan ahead for MBA Admission 2026, you’ll be well prepared
              to meet deadlines and secure a seat in your preferred college
              without last-minute stress.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 2: What are the eligibility criteria for MBA Admission
              2026?
            </h6>
            <p>
              The eligibility criteria for MBA Admission 2026 will generally
              remain the same as previous years. To apply, you must hold a
              Bachelor’s degree in any discipline from a recognized university
              with a minimum of 50% aggregate marks (45% for reserved categories
              like SC/ST). Some top institutes may require a slightly higher
              percentage or specific academic backgrounds for specialized MBA
              programs. If you’re targeting MBA Admission 2026 in premier
              institutions like IIMs or top private colleges, you should also be
              prepared with valid entrance exam scores such as CAT 2026, XAT
              2026, GMAT, or other relevant tests. Work experience is not
              mandatory for all colleges, but it can strengthen your
              application, especially for executive MBA programs. Additionally,
              candidates in their final year of graduation in 2026 are also
              eligible to apply for MBA Admission 2026, provided they can submit
              proof of completion by the time classes commence.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 3: Which entrance exams are required for MBA Admission
              2026?
            </h6>
            <p>
              For MBA Admission 2026, your choice of entrance exam will depend
              on the colleges you want to target. The most popular exam is the
              CAT 2026, which is accepted by all IIMs and many top B-schools
              across India. Other popular exams include XAT 2026 (for XLRI and
              allied institutes), SNAP 2026 (for Symbiosis institutes), NMAT
              2026, CMAT 2026, and MAT. Some colleges also accept GMAT scores
              for both domestic and international applicants seeking MBA
              Admission 2026. Make sure to check the specific exams accepted by
              your shortlisted colleges. For example, some private universities
              conduct their own entrance tests like TISSNET for TISS, MICAT for
              MICA, or IIFT for the Indian Institute of Foreign Trade. Keep an
              eye on exam notifications, deadlines, and syllabus changes.
              Preparing well for these exams is crucial because your score will
              heavily impact your chances of securing MBA Admission 2026 at a
              reputed institute.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 4: When will the application process start for MBA
              Admission 2026?
            </h6>
            <p>
              The application process for MBA Admission 2026 typically starts in
              the second half of 2026. For example, IIMs usually open their CAT
              registration in August 2026, and the test is held in November or
              December 2026. Based on the CAT result, the selection rounds for
              MBA Admission 2026 — including group discussions, written ability
              tests, and personal interviews — will be conducted between January
              and April 2026. Private B-schools like XLRI, Symbiosis, NMIMS, and
              others also follow a similar timeline, opening applications 6-8
              months before the new academic session begins. So if you are
              targeting MBA Admission 2026, it’s wise to keep an eye on each
              college’s official website for exact dates, early bird
              applications, and important deadlines. Late applications often
              reduce your chances of getting your preferred specialization or
              campus, so planning ahead ensures you don’t miss out.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 5: How can I choose the best college for MBA Admission
              2026?
            </h6>
            <p>
              Choosing the right college for MBA Admission 2026 is crucial for
              your career growth. Start by researching colleges based on factors
              like accreditation (AICTE/UGC approval), ranking, faculty quality,
              specialization options, industry connections, placement records,
              and alumni network. Shortlist colleges that match your career
              goals — for example, some B-schools are best known for finance,
              while others excel in marketing, operations, or HR. Location also
              matters; cities like Mumbai, Bangalore, Pune, and Delhi offer
              better exposure and networking for MBA Admission 2026. Check each
              college’s admission process, cut-off scores, and fee structure.
              Visit official websites, attend webinars, and participate in
              college fests or admission counseling sessions to get authentic
              insights. For MBA Admission 2026, read reviews, talk to alumni,
              and compare placement reports to understand ROI (return on
              investment). Make an informed choice to ensure you get quality
              education and good career opportunities after your MBA.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 6: What is the fee structure for MBA Admission 2026?
            </h6>
            <p>
              he fee for MBA Admission 2026 will vary depending on the college,
              specialization, and location. For top IIMs, the two-year MBA
              program can cost anywhere between ₹18 lakhs to ₹30 lakhs.
              Similarly, leading private B-schools like XLRI, SPJIMR, or ISB may
              charge between ₹15 lakhs and ₹30 lakhs. Tier-2 or Tier-3 colleges
              offering MBA Admission 2026 may have a fee range of ₹5 lakhs to
              ₹12 lakhs. Apart from tuition fees, consider other expenses like
              hostel fees, mess charges, study materials, and additional costs
              for internships or global immersion programs. Many colleges also
              offer scholarships, tuition waivers, or financial aid based on
              merit, entrance scores, or special categories for MBA Admission
              2026. You can also apply for education loans from banks, which
              cover tuition and living expenses. Always verify the total cost
              from the college’s official prospectus and plan your finances
              early to avoid last-minute stress.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 7: Is work experience mandatory for MBA Admission 2026?
            </h6>
            <p>
              For regular two-year MBA programs under MBA Admission 2026, work
              experience is usually not mandatory but can add significant value
              to your application. Many fresh graduates directly pursue an MBA
              to boost their career prospects. However, top B-schools like IIMs
              or ISB do prefer candidates with at least 1-3 years of work
              experience, especially for executive MBA or PGPX programs. Work
              experience helps you understand real-world business scenarios
              better and adds depth during group discussions or interviews for
              MBA Admission 2026. It can also make you eligible for lateral
              placements and senior roles after graduation. If you don’t have
              prior experience, you can still strengthen your profile with
              internships, certifications, volunteering, and leadership roles in
              college activities. So while work experience isn’t compulsory for
              all, it definitely gives you an edge in the highly competitive MBA
              Admission 2026 process.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 8: What documents are needed for MBA Admission 2026?
            </h6>
            <p>
              When applying for MBA Admission 2026, keep all required documents
              ready to avoid delays. The basic documents include your 10th and
              12th mark sheets, Bachelor’s degree mark sheets and provisional or
              original degree certificate. You’ll also need valid entrance exam
              scorecards for CAT, XAT, GMAT, or other tests relevant for MBA
              Admission 2026. Identity proofs like Aadhaar card, PAN card, or
              passport are mandatory. If you have work experience, arrange offer
              letters, experience certificates, and payslips. Some colleges may
              ask for letters of recommendation (LORs) or Statements of Purpose
              (SOPs). Be ready with passport-size photographs and category
              certificates if you’re applying under SC/ST/OBC quota.
              International applicants may need additional documents like
              TOEFL/IELTS scores or passport copies. Always carry both originals
              and multiple photocopies of all documents for MBA Admission 2026
              interviews or counseling sessions. Keeping everything organized
              helps you secure your seat without any last-minute hassle.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 9: What are the placement prospects after MBA Admission
              2026?
            </h6>
            <p>
              Placement prospects for students after MBA Admission 2026 are
              expected to remain strong, as the demand for skilled management
              graduates continues to rise. Top B-schools have robust placement
              cells that connect students with leading recruiters from diverse
              industries like consulting, banking, FMCG, IT, e-commerce, and
              start-ups. Many institutes offering MBA Admission 2026 will have
              tie-ups with companies for internships and final placements.
              Average salary packages for IIMs and top private B-schools can
              range from ₹15 lakhs to ₹30 lakhs per annum, with top performers
              getting even higher CTCs. Placement success depends on your
              specialization, academic performance, industry exposure,
              networking, and soft skills. Students who leverage internships,
              live projects, case competitions, and alumni connections during
              their MBA journey tend to secure better job roles and higher
              salaries. So, while MBA Admission 2026 opens the door, your
              performance during the course decides your final placement
              opportunities.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 10: Can I get MBA Admission 2026 through Management Quota?
            </h6>
            <p>
              Yes, many private colleges reserve a certain percentage of seats
              under management quota for MBA Admission 2026. This option is
              helpful if you didn’t score well enough in entrance exams or
              missed the cut-offs but still wish to secure a seat in a reputed
              institute. Colleges that offer MBA Admission 2026 through
              management quota must follow state or university guidelines and
              disclose the seat matrix. Management quota seats may have a higher
              fee structure and require direct interaction with the college’s
              admission office or an authorized consultant. If you plan to opt
              for MBA Admission 2026 under management quota, ensure you approach
              only trusted sources to avoid fraud. Keep your documents ready and
              apply early since these seats are limited and filled on a
              first-come, first-served basis. Always demand official receipts
              and admission confirmation letters to secure your MBA Admission
              2026 transparently and legally.
            </p>
          </div>
        </Container>
      </section>

      {/* instruction section start  */}

      {/* top college details start*/}

      {/* enquiry form section start */}
      <m.section
        className="py-[160px] bg-cover 	bg-no-repeat overflow-hidden relative bg-center lg:py-[120px] md:py-[95px] xs:py-[80px] xxs:py-[50px]"
        style={{
          backgroundImage:
            "url(/assets/img/webp/MedicalCounsellingIndia/home/enquiry/enquiry.webp)",
        }}
        {...fadeIn}
      >
        <Container className="xs:px-0">
          <div className="flex justify-center mb-[100px] w-full">
            <p className="font-normal text-[20px] w-[70%] lg:w-[70%] md:w-[100%] text-center">
              Get Top Education Consultant in Jamshedpur. Kindly submit your
              data below and we shall connect you as soon as possible.
            </p>
          </div>
          <Row className="justify-end md:justify-center">
            <Col xl={7} lg={7} md={9} sm={11}>
              <div className="px-[3rem] py-[5rem] rounded-md shadow-[0_0_30px_rgb(0,0,0,0.08)] bg-white sm:p-20 xs:rounded-none xs:px-[3.5rem] xs:py-[6rem]">
                <span className="mb-[15px] font-medium text-center text-[#f78c1f] text-md font-serif uppercase block sm:mb-[10px]">
                  Submit your details here
                </span>
                <h5 className="w-[80%] mb-[40px] font-bold text-center	tracking-[-1px] text-black font-serif uppercase mx-auto xs:w-full">
                  YOU ARE JUST A CALL AWAY
                </h5>

                <form className="mb-[30px]" onSubmit={handleSubmit(onSubmit)}>
                  <m.div
                    className="row justify-center"
                    {...{ ...fadeIn, transition: { delay: 0.6 } }}
                  >
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="name"
                          className="rounded-[5px] relative py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "Name is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.name?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="email"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your email address"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Email is required.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                              message: "Enter valid email",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.email?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="number"
                          name="phone"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your phone number"
                          onKeyDown={handleKeyDown}
                          {...register("phone", {
                            required: {
                              value: true,
                              message: "Phone number is required",
                            },
                            pattern: {
                              value:
                                /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                              message: "Enter valid phone number",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.phone?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="address"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your address"
                          {...register("address", {
                            required: {
                              value: true,
                              message: "Address is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.address?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="stream"
                          className="rounded-[5px] py-[13px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Subject"
                          {...register("stream", {
                            required: {
                              value: true,
                              message: "Stream is required",
                            },
                            value: "Subject",
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.stream?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <textarea
                          type="text"
                          rows={3}
                          name="message"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your message"
                          {...register("message", {
                            required: {
                              value: true,
                              message: "Message is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-10px] translate-x-[10px]">
                          {errors.message?.message}
                        </div>
                      </div>
                    </Col>
                  </m.div>

                  <Buttons
                    type="submit"
                    className={`btn-fill text-sm leading-none font-medium tracking-[1px] !py-[17px] px-[32px] rounded-[4px] w-full uppercase mb-[5px] ${
                      formLoading ? "loading" : ""
                    }`}
                    themeColor="#f78c1f"
                    color="#fff"
                    size="lg"
                    title="Request a call schedule"
                  />
                </form>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </m.section>
      {/* enquiry form section end */}
    </>
  );
}

export default MbaAdmission;
